import React from "react";
import {Box} from "@mui/system";
import {parseEscapedText, replaceHttp, parseMarkdown} from "_helpers";
import linkifyHtml from "linkify-html";
import dompurify from "dompurify";
import fustatMedium from "../../../../fonts/Fustat/Fustat-Medium.ttf";

function ProactiveMetricsMessageIframe({
  text,
  index,
  messageSource,
}) {
  const offset = 20;
  const isHtml = /<\/?[a-z][\s\S]*>/i.test(text);

    let formattedText = text;
    // Formatting for Mobius messages
    if (messageSource && messageSource.toLowerCase() === 'mobius') {
        formattedText = parseEscapedText(formattedText);
        formattedText = replaceHttp(formattedText);
        formattedText = dompurify.sanitize(formattedText);
        formattedText = linkifyHtml(formattedText, {
          target: "_blank",
          rel: "noopener noreferrer",
        });

        if (isHtml) {
            formattedText = parseEscapedText(text);
            formattedText = dompurify.sanitize(formattedText);
        } else {
            formattedText = parseMarkdown(text, true);
        }
    }

    formattedText = `<base target="_blank">` + formattedText;
    const fontStyle = `
    <style>
      @font-face {
        font-family: FustatMedium;
        src: url("${fustatMedium}") format("truetype");
        font-weight: 600;
        font-style: normal;
        font-display: swap;
      }
      .fustat-semi-bold, body { font-family: FustatMedium; font-size: 14px; }
    </style>
  `;
    const iframeHtml =
        fontStyle + `<div class="fustat-semi-bold">${formattedText}</div>`;

  const onLoad = () => {
    return setTimeout(() => {
      const obj = document.getElementById(`${index}-pmc-messageFrame`);
      if (obj) {
        obj.style.height =
          obj.contentWindow.document.body.scrollHeight + offset + "px";
      }
    }, 50);
  };

    return(
        <Box component={'iframe'}
             id={`${index}-pmc-messageFrame`}
             scrolling={'no'}
             sx={styles.iframe}
             srcDoc={iframeHtml}
             onLoad={onLoad}
        />
    )
}

export default React.memo(ProactiveMetricsMessageIframe)

const styles = {
    iframe: {
        width: '100%',
        border: 0,
    },
}